import { useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { HistoryTabKeys, historyActions } from "./historySlice";

type ListQuery = {
  page: number;
  size: number;
  ascending: boolean;
  filter: string;
  fromDate: string;
  toDate: string;
  selectedTab: HistoryTabKeys;
};

export const useHistoryList = () => {
  const dispatch = useAppDispatch();
  const historyList = useAppSelector((state) => state.history.list);

  const actions = useMemo(
    () => ({
      fetchList: (payload: ListQuery) =>
        dispatch(historyActions.fetchHistoryListRequested(payload)),
    }),
    [dispatch]
  );

  return {
    ...historyList,
    ...actions,
  };
};

export const useHistoryDetail = () => {
  const dispatch = useAppDispatch();
  const historyDetail = useAppSelector((state) => state.history.detail);

  const actions = useMemo(
    () => ({
      fetchDetail: (payload: {
        transactionId: string;
        selectedTab: HistoryTabKeys;
        transactions: any[];
        forceRefresh?: boolean;
      }) => {
        const isDuplicateInFlight =
          !payload.forceRefresh &&
          historyDetail.loading &&
          historyDetail.currentTransactionId === payload.transactionId;
        if (isDuplicateInFlight) return;
        dispatch(historyActions.fetchHistoryDetailRequested(payload));
      },
      clearDetail: () => dispatch(historyActions.clearHistoryDetail()),
    }),
    [dispatch, historyDetail.loading, historyDetail.currentTransactionId]
  );

  return {
    ...historyDetail,
    ...actions,
  };
};
